// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Col, Button, Row, Modal } from 'react-bootstrap'
import { ModuleItem } from '../components/moduleItem'
import { Message } from '../components/message'
import config from '../config/config.json'
import { evalRatingModule, fixScrollbar, getCategoriesString } from '../utils/enUtils.js'

export class WorkerContent extends Component {
    constructor(props) {
        super(props)

        this.path = {
            modules: '/assets/images/Modules/'
        }

        this.state = {
            showDeleteProviderModal: false,
            deleteProvider: false
        }

        this.viewPerformance = this.viewPerformance.bind(this)
        this.viewCertificate = this.viewCertificate.bind(this)
        this.handleDisconnectWorker = this.handleDisconnectWorker.bind(this)
        this.openDeleteProviderModal = this.openDeleteProviderModal.bind(this)
        this.closeDeleteProviderModal = this.closeDeleteProviderModal.bind(this)
        this.confirmDeleteProvider = this.confirmDeleteProvider.bind(this)
    }

    viewPerformance(e) {
        e.preventDefault()

        this.props.handleViewPerformance(e.target.getAttribute("data-moduleName"))
    }

    viewCertificate(e) {
        e.preventDefault()

        this.props.handleViewCertificate(e.target.getAttribute("data-moduleName"))
    }

    loadActionButtons(module) {
        return (
            <Row>
                <Col sm={4}>
                    <Button bsStyle="primary" data-moduleName={module.name} onClick={this.viewPerformance}>View Performance</Button>
                    <span></span>
                </Col>
                <Col sm={4}>
                    <Button bsStyle="primary" data-moduleName={module.name} onClick={this.viewCertificate}>View Certificate</Button>
                    <span></span>
                </Col>
                <Col sm={4} style={{ "display": "none" }}>
                    <Button bsStyle="primary" onClick={() => { window.open(module.webgl_url, '_blank') }}>Play Game</Button>
                </Col>
            </Row>
        )
    }

    loadWebglWarning() {
        return (
            <Row>
                <Col smOffset={1} sm={11} style={{ "display": "none" }}>
                    <span className="note-message">*Playing this module in your browser cannot generate results at this time. Please download the Enabler app to complete assignments.</span>
                </Col>
            </Row>
        )
    }

    prepareModuleItems() {
        let activeModulesSorted = this.props.activeModules
        activeModulesSorted.sort((a, b) => (a.name < b.name) ? -1 : 1)

        return activeModulesSorted.map((module, index) => {
            return (
                <ModuleItem
                    key={index}
                    image={module.icon}
                    name={module.name}
                    status={evalRatingModule(module.completed, module.average_strikes)}
                    category={getCategoriesString(module.category)}
                    summary={module.summary}
                >
                    {this.loadActionButtons(module)}
                    {this.loadWebglWarning()}
                </ModuleItem>
            )
        })
    }

    prepareModuleListing() {
        if (this.props.activeModules.length === 0) {
            return (
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <Message
                            text="Thank you for verifying your account! Please note, modules may take up to 24 hours to appear as they are manually added by an administrator. We'll notify you via email as soon as they're ready to go."
                        >
                        </Message>
                    </Col>
                </Row>
            )
        }
        else {
            return (
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <section className="foundation-modules">
                            <h3 className="category-title">All Modules</h3>
                            {this.prepareModuleItems()}
                        </section>
                    </Col>
                </Row>
            )
        }
    }

    openDeleteProviderModal() {
        this.setState({
            showDeleteProviderModal: true
        })
    }

    closeDeleteProviderModal() {
        this.setState({
            showDeleteProviderModal: false,
            deleteProvider: false,
        })

        fixScrollbar()
    }

    confirmDeleteProvider() {
        this.props.disconnectWorker(this.props.activeProviderId, this.props.env)

        this.setState({
            showDeleteProviderModal: false,
            deleteProvider: true
        })

        fixScrollbar()
    }

    handleDisconnectWorker(e) {
        e.preventDefault()
    }

    prepareDeleteProviderModal() {
        return (
            <Modal show={this.state.showDeleteProviderModal} onHide={this.closeDeleteProviderModal}>
                <Modal.Header>
                    <Modal.Title componentClass="h2">Confirm Disconnection</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h4><b>Are you sure</b> you want to disconnect from {this.props.activeProviderName}?</h4>
                    <br />
                    <h4>You will <b>lose access</b> to all modules they have granted you access to.</h4>
                </Modal.Body>
                <Modal.Footer>
                    <Row>
                        <Col sm={6}>
                            <Button bsStyle="primary" onClick={this.confirmDeleteProvider}>Confirm</Button>
                        </Col>
                        <Col sm={6}>
                            <Button bsStyle="primary" onClick={this.closeDeleteProviderModal}>Cancel</Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>
        )
    }

    loadDisconnectProviderButton() {
        if (this.props.activeProviderId === config.consts.MY_CONTENT_KEY ||
            this.props.activeProviderId === config.consts.MY_CERT_KEY) {
            return (
                <Row />
            )
        }
        return (
            <Row>
                <Col smOffset={9} mdOffset={9} xsOffset={9} sm={2} md={2} xs={2}>
                    <Button bsClass="disconnect" onClick={this.openDeleteProviderModal}>Disconnect</Button>
                </Col>
            </Row>
        )
    }

    render() {
        return (
            <section className="training-content">
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <div className="main-header">
                            <h2 className="title">Available Training</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col sm={10} md={10} xs={10} smOffset={1} mdOffset={1} xsOffset={1}>
                        <p>To proceed with training, please download the Enabler app:</p>
                        <Col md={1}>
                            <p><a href="https://apps.apple.com/au/app/enabler/id1423438333">
                                <img src="/assets/images/app-store-badge.png" alt="download-app-store" style={{ width: 256, height: 76 }} />
                            </a></p>
                            <p><a href="https://play.google.com/store/apps/details?id=com.enablerinteractive.enabler.android.Enabler">
                                <img src="/assets/images/google-play-badge.png" alt="download-google-play" style={{ width: 256, height: 76 }} />
                            </a></p>
                        </Col>
                    </Col>
                </Row>
                {this.loadDisconnectProviderButton()}
                {this.prepareModuleListing()}
                {this.prepareDeleteProviderModal()}
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/workerContent.js